import { Schema as S } from "effect";

import {
	HistoryVersion,
	NullAsEmpty,
	NullByDefault,
	Page,
	Provenance,
	ProvenancePerson,
} from "./common";

/** The same shape as a provenance person; one definition, two names. */
export const EntryAuthor = ProvenancePerson;

/** Server `entryDbToApi` (core/entryConversion.ts): `title` is the nullable `object.name` column. */
export const Entry = S.Struct({
	id: S.String,
	circleId: S.String,
	nodeIds: S.Array(S.String),
	type: S.String,
	title: NullAsEmpty,
	description: S.String,
	tags: S.Array(S.String),
	json: S.optionalKey(S.NullOr(S.String)),
	attributes: S.optionalKey(S.Record(S.String, S.String)),
	timestamp: S.String,
	createdBy: S.optionalKey(S.NullOr(S.String)),
	author: S.optionalKey(S.NullOr(EntryAuthor)),
	/** The creating write; absent from responses older than the provenance feature. */
	provenance: S.optionalKey(S.NullOr(Provenance)),
	/** The current version's write when it differs from the creating one. */
	lastEdit: S.optionalKey(S.NullOr(Provenance)),
});
export type Entry = typeof Entry.Type;

export const UploadedFileInfo = S.Struct({
	id: S.String,
	key: S.String,
	name: S.String,
	size: S.Number,
	contentType: S.optionalKey(S.String),
	uploadedAt: S.String,
});

export const UploadEntryResponse = S.Struct({
	success: S.Boolean,
	created: S.String,
	file: UploadedFileInfo,
});

export const DownloadedFile = S.Struct({
	blob: S.instanceOf(Blob),
	fileName: S.optional(S.String),
	contentType: S.optional(S.String),
});
export type DownloadedFile = typeof DownloadedFile.Type;

/**
 * Raw `object_history` columns (same `getObjectHistory` as records): the entry title is
 * `name`, and json/timestamp/createdBy live inside the `data` blob. The v1-typed
 * top-level fields default to null so pages keep their contract.
 */
export const EntryHistoryEntry = HistoryVersion(
	S.Struct({
		type: S.String,
		name: S.optionalKey(S.NullOr(S.String)),
		title: NullByDefault,
		description: S.NullOr(S.String),
		tags: S.NullOr(S.String),
		json: NullByDefault,
		attributes: S.NullOr(S.String),
		data: S.optionalKey(S.Unknown),
		timestamp: NullByDefault,
		createdBy: NullByDefault,
	}),
);
export type EntryHistoryEntry = typeof EntryHistoryEntry.Type;

export const EntryHistory = Page(EntryHistoryEntry);
